"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.998 18.422H5.776c-.815 0-1.483-.454-1.75-1.192-.286-.784-.074-1.586.563-2.11.28-.23.566-.448.764-.759.253-.394.39-.82.39-1.29.002-1.303-.013-2.605.007-3.908.045-2.94 2.173-5.5 5.054-6.04 2.045-.384 3.867.132 5.41 1.536 1.195 1.086 1.846 2.458 2.013 4.06.02.193.025.39.026.584.003 1.265-.006 2.53.005 3.796.007.72.308 1.313.857 1.779.151.128.312.248.453.388.53.523.676 1.316.381 2.025-.29.698-.93 1.13-1.68 1.13zm.002-1.39h6.108q.07 0 .137-.002a.46.46 0 0 0 .433-.314.45.45 0 0 0-.137-.507c-.087-.076-.18-.147-.27-.221-.924-.765-1.4-1.746-1.406-2.947-.006-1.207.005-2.414-.005-3.621a6 6 0 0 0-.08-.99c-.402-2.23-2.23-3.828-4.327-4.008-1.507-.13-2.807.343-3.876 1.406a4.72 4.72 0 0 0-1.432 3.368c-.023 1.294-.006 2.589-.01 3.883a3.7 3.7 0 0 1-.764 2.254c-.253.34-.577.603-.902.869a.46.46 0 0 0 .061.765c.092.05.214.062.322.062q3.074.004 6.147.003m.007 2.573c.61 0 1.219-.003 1.829.001.412.003.717.309.713.703-.004.397-.315.69-.742.69h-3.41c-.11 0-.224.006-.334-.01a.69.69 0 0 1-.608-.728.687.687 0 0 1 .698-.654c.618-.006 1.236-.002 1.854-.002"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertIcon24.js.map